export default __webpack_public_path__ + "static/media/A1.912a0abc.mp3";